import { Grid, InputAdornment, TextField } from '@mui/material';
import React, { useContext } from 'react';
import { ISearchForm } from '../../../interfaces/bookingContext';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { TicketCoupon } from '@vectopus/atlas-icons-react';
import {website} from "@/utils/helpers";

const SetCouponField = (props: any) => {
  const useStyles = makeStyles()((theme) => {
    return {
      couponField: {
        backgroundColor: website.code === 'VP' ? '#FFFFFF' : '#f5f5f5',
        border: website.code === 'VP' ? '1px solid #D9D9D9' : 'none',
        position: 'relative',
        alignItems: 'normal',
        minHeight: 58,
        justifyContent: 'center',
        borderRadius: theme.radius.formBorderRadius,
        [theme.breakpoints.down('md')]: {
          backgroundColor: '#FFF',
          '.MuiInputBase-root': {
            width: '100%!important'
          }
        },
        '.MuiInputBase-root': {
          /*paddingRight: '32px',*/
          border: 'none!important',
          fontSize: 14,
          /*input: {
            padding: '0 24px'
          },*/
          'i::before': {
            color: '#000'
          },
          fieldset: {
            border: 'none'
          }
        }
      },
      couponField2: {
        backgroundColor: website.code === 'VP' ? '#FFFFFF' : '#f5f5f5',
        border: website.code === 'VP' ? '1px solid #D9D9D9' : 'none',
        borderRadius: website.code === 'VP' ? 0 : 5,
        height: '58px!important',
        justifyContent: 'center',
        textAlign: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          '.MuiInputBase-root': {
            border: 'none!important',
            width: '100%!important',
            paddingLeft: '4px!important'
          },
          svg: {
            display: website.code === 'VP' ? 'flex' : 'none',
            paddingRight: website.code === 'VP' ? '20px' : 0
          }
        }
      }
    };
  });

  const appContext = useContext(AppContext);
  const { classes } = useStyles();
  const { t } = useTranslation();

  /*const handleCouponChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    /!*appContext.resetAvailability();*!/
    appContext.setUpdateSearch(true);
    /!*appContext.searchForms[appContext.orderIndex].status = 'to_start';*!/
    const clone: ISearchForm[] = [...appContext.searchForms];
    clone[0].Coupon = event.target.value.toString().replace(/^\uFEFF/, '').trim().toUpperCase();
    appContext.setSearchForms(clone);
  };*/

  const handleCouponChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    appContext.setUpdateSearch(true);

    const coupon = event.target.value
      .toString()
      .replace(/^\uFEFF/, '')
      .trim()
      .toUpperCase();

    const allAccommodationsInSearchForm = appContext.searchForms.map(form => ({
      ...form,
      Coupon: coupon,
    }));

    appContext.setSearchForms(allAccommodationsInSearchForm);
  };

  const container = props.params.container;

  return (
    <Grid size={{ xs: 12, sm: 12, md: 2, lg: 3 }} id={'promoCode'}>
      {
        container === 'DrawerSearchWidget' ? (
          <TextField
            variant={'outlined'}
            name={'Coupon'}
            placeholder={t('Coupon')}
            value={appContext.searchForms[appContext.orderIndex].Coupon}
            onChange={handleCouponChange}
            className={container === 'SearchBarMobile' ? classes.couponField2 : classes.couponField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <TicketCoupon size={18} />
                </InputAdornment>
              )
            }}
          />
        ) : (
          <TextField
            variant={'outlined'}
            name={'Coupon'}
            placeholder={t('Coupon')}
            value={appContext.searchForms[appContext.orderIndex].Coupon}
            onChange={handleCouponChange}
            className={container === 'SearchBarMobile' ? classes.couponField2 : classes.couponField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="end">
                  <TicketCoupon size={ website.code === 'VP' ? 20 : 18} />
                </InputAdornment>
              ),
              sx: website.code === 'VP' ? {
                color: '#000',
                '& input::placeholder': {
                  color: '#000',
                  opacity: 1,
                  transform: 'translateY(2px)',
                },
              } : {},
            }}
          />
        )
      }
    </Grid>
  );
};

export default SetCouponField;
